import { captureMiddlewareError } from './captureMiddlewareError'
import { captureMiddlewarePerformance } from './captureMiddlewarePerformance'
import { getMiddlewareHeaders } from './getMiddlewareHeaders'
import { getMiddlewareUrl } from './getMiddlewareUrl'
import { getSessionValue } from '../default/getSessionValue'

/**
 * Verifies an otp code
 * @param {string} code - The otp code
 * @param {string} phone - The phone associated with the code
 * @param {string} sessionId - The session ID
 * @returns {Promise<any>}
 */
export async function verifyCodeVeracity(
  code,
  phone,
  sessionId = 'tdMainFunnel',
) {
  const apiBase = getMiddlewareUrl()
  const endpoint = '/api/veracity/complete'
  const url = `${apiBase}${endpoint}`

  const startTime = performance.now()
  try {
    const funnel = getSessionValue(sessionId, 'funnel') || ''
    const affId = getSessionValue(sessionId, 'aff_id') || ''
    const utmCampaign = getSessionValue(sessionId, 'utm_campaign') || ''
    const trid = getSessionValue(sessionId, 'trid') || ''

    const body = JSON.stringify({
      code,
      phone,
      funnel,
      aff_id: utmCampaign || affId,
      trid,
    })
    const response = await fetch(url, {
      body,
      headers: getMiddlewareHeaders(),
      method: 'POST',
    })

    captureMiddlewarePerformance(url, performance.now() - startTime)

    const data = await response.json()
    if (
      data?.success === false ||
      data?.message == 'No pending verification for this phone number.'
    ) {
      throw Error(data?.message || 'invalid otp code')
    }
    return data.data?.meta || {}
  } catch (error) {
    captureMiddlewarePerformance(url, performance.now() - startTime)
    captureMiddlewareError(url, /** @type {Error} */ (error), false)
    return {}
  }
}
